module.exports = __webpack_public_path__ + "static/media/rx.ee0116e5.png";